import React, { useState, useEffect, useMemo } from 'react'
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { ArrowDownOnSquareIcon, ArrowDownTrayIcon, ArrowsPointingOutIcon, XMarkIcon } from '@heroicons/react/20/solid';
import Select from "react-select";
import { usePDFDownload, useExcelDownload } from "../../../helper/HelperTwo";
import { TableCellsIcon } from '@heroicons/react/24/outline';

const LeadReportList = () => {

  const [loading, setLoading] = useState(false);
  const tabName = localStorage.getItem("tab_name");
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [statsDetails, setStatsDetails] = useState({});
  const [futureLeadList, setFutureLeadList] = useState([]);
  const [nonFollowedLeadList, setNonFollowedLeadList] = useState([]);
  const [todayLeadList, setTodayLeadList] = useState([]);
  const [leadCountsByTypeOfWork, setLeadCountsByTypeOfWork] = useState([]);
  const [colors, setColors] = useState([]);
  const [fullscreenTable, setFullscreenTable] = useState(null);
  const [typeOfWork, setTypeOfWork] = useState([]);
  const { PDFDownload } = usePDFDownload();
  const { excelDownload } = useExcelDownload();
  const [projectManagerList, setProjectManagerList] = useState([]);

  const [leadFilter, setLeadFilter] = useState({
    date_from: "",
    date_to: "",
    date_filter: "",
    type_of_work: "",
    type: tabName || "",
    project_manager: "",
  })


  const handleChange = (e) => {
    const { name, value } = e.target;
    
    setLeadFilter({
      ...leadFilter,
      [name]: value,
    });
  };

  const fetchLead = async () => {
    const token = localStorage.getItem("token");
    setLoading(true);
    try {
      const response = await axios.get("public/api/report/leads?type=" + tabName, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const typeOfWork = await axios.get("public/api/type-of-works/list", {
        headers: { Authorization: `Bearer ${token}` },
      });
      const projectManager = await axios.get("public/api/project-manager/list", {
        headers: { Authorization: `Bearer ${token}` },
      });
      
      setProjectManagerList(projectManager?.data);
      setTypeOfWork(typeOfWork?.data);

      setStatsDetails(response.data);
      setColors(generateColors(response?.data?.typeOfWork));
    } catch (error) {
      if (error?.response?.status === 401) {
        localStorage.removeItem("token");
        navigate("/crm/");
      }
      setError(error.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchLead();
  }, []);

  const generateColors = (count) => {
    const colors = [];
    // for (let i = 0; i < count; i++) {
    //   const color = `#${Math.floor(Math.random() * 16777215).toString(16)}`;
    //   colors.push(color);
    // }
     for (let i = 0; i < count; i++) {
      const hue = Math.floor(Math.random() * 360); // full color range
      const saturation = Math.floor(Math.random() * 40) + 70; // 70–100% = very colorful
      const lightness = Math.floor(Math.random() * 30) + 25; // 60–90% = bright

      const color = `hsl(${hue}, ${saturation}%, ${lightness}%)`;
      colors.push(color);
    }

    return colors;
  };

  const getRandomColorClass = () => {
    return colors[Math.floor(Math.random() * colors.length)];
  };
  const randomColorMap = useMemo(() => {
    const map = {};
    statsDetails?.nonFollowedLeadList?.forEach((lead) => {
      lead?.type_of_work?.forEach((work) => {
        if (!map[work.id]) {
          map[work.id] = getRandomColorClass();
        }
      });
    });
    return map;
  }, [statsDetails]);
  const futureLeadColorMap = useMemo(() => {
    const map = {};
    statsDetails?.futureLeadList?.forEach((lead) => {
      lead?.type_of_work?.forEach((work) => {
        if (!map[work.id]) {
          map[work.id] = getRandomColorClass();
        }
      });
    });
    return map;
  }, [statsDetails]);

  const todayLeadColorMap = useMemo(() => {
    const map = {};
    statsDetails?.todayLeadList?.forEach((lead) => {
      lead?.type_of_work?.forEach((work) => {
        if (!map[work.id]) {
          map[work.id] = getRandomColorClass();
        }
      });
    });
    return map;
  }, [statsDetails]);


  const handleFilter = async () => {
    try {
      const token = localStorage.getItem("token");
      setLoading(true);

      const response = await axios.get("public/api/report/leads", {
        params: {
          date_from: leadFilter.date_from || "",
          date_to: leadFilter.date_to || "",
          date_filter: leadFilter.date_filter || "",
          type_of_work: leadFilter.type_of_work || "",
          type: leadFilter.type || "",
          project_manager: leadFilter.project_manager || "",
        },
        headers: { Authorization: `Bearer ${token}` },
      });

      setStatsDetails(response.data);
      setColors(generateColors(response?.data?.typeOfWork));
    } catch (error) {
      if (error?.response?.status === 401) {
        localStorage.removeItem("token");
        navigate("/crm/");
      }
      setError(error.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  }


  const resetFilters = () => {
    setLeadFilter({
      date_from: "",
      date_to: "",
      date_filter: "",
      type_of_work: "",
      type:tabName || "",
      project_manager: "",
    });
    fetchLead();
  }

  const salesServiceOptions = [
    {
      value: "sales",
      name: "Sales",
    },
    {
      value: "service",
      name: "Service",
    },
  ];

  const downloadPDF = (leadPdfType, title) => {
    const params = {
      date_from: leadFilter.date_from || "",
      date_to: leadFilter.date_to || "",
      date_filter: leadFilter.date_filter || "",
      type_of_work: leadFilter.type_of_work || "",
      type: leadFilter.type || "",
      pdf_type: leadPdfType || "",
      pdf_title:title || "",
      project_manager: leadFilter.project_manager || "",

    }
    PDFDownload('report/leads', 'leads.pdf', params, setLoading);
  }
  const downloadExcel = (leadExcelType ,  title) => {
    const params = {
      date_from: leadFilter.date_from || "",
      date_to: leadFilter.date_to || "",
      date_filter: leadFilter.date_filter || "",
      type_of_work: leadFilter.type_of_work || "",
      type: leadFilter.type || "",
      pdf_type: leadExcelType || "",
      project_manager: leadFilter.project_manager || "",
      excel_title:title || "",
    }
    excelDownload('report/leads', 'leads.xlsx', params, setLoading);
  }


  if (loading) {
    return (
      <div class="h-screen bg-white">
        <div class="flex justify-center items-center h-full">
          <img
            class="h-16 w-16"
            src="https://icons8.com/preloaders/preloaders/1488/Iphone-spinner-2.gif"
            alt="loader"
          />
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="h-screen bg-white flex flex-col justify-center items-center">
        <p className="mb-4 text-red-600 font-medium">Something went wrong.</p>
        <button
          className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
          onClick={() => {
            setError(null); // hide error while retrying
            fetchLead(); // retry API
          }}
        >
          Reload
        </button>
      </div>
    )
  }

  return (
    <div>
      <div>
        <h2 className="text-md sm:text-2xl font-semibold mb-4">Lead Report</h2>
        <div className="grid grid-cols-1 sm:grid-cols-5 gap-4 mt-4">
          <div className="space-y-3 ">
            <div className="">
              <label className="block text-sm font-medium text-gray-700">
                Filter by date
              </label>
              <select
                name="date_filter"
                value={leadFilter.date_filter}
                onChange={handleChange}
                className="border border-gray-300 p-1.5 rounded w-full mt-2"
              >
                <option value="" className="text-gray-300">
                  -- Select --
                </option>
                <option value="today">Today</option>
                <option value="yesterday">Yesterday</option>
                <option value="this_week">This Week</option>
                <option value="this_month">This Month</option>
                <option value="this_year">This Year</option>
                <option value="custom">Custom Range</option>
              </select>
            </div>
          </div>

          {leadFilter.date_filter === "custom" && (
            <>
              <div className="space-y-3 ">
                <div className="">
                  <label className="block text-sm font-medium">
                    Date From
                  </label>
                  <input
                    type="date"
                    name="date_from"
                    value={leadFilter.date_from}
                    onChange={handleChange}
                    className="mt-2 w-full rounded border border-gray-300 p-2 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200"
                  />
                </div>
              </div>
              <div className="space-y-3 ">
                <div className="w-full">
                  <label className="block text-sm font-medium">
                    Date To
                  </label>
                  <input
                    type="date"
                    name="date_to"
                    value={leadFilter.date_to}
                    onChange={handleChange}
                    className="mt-2 w-full rounded border border-gray-300 p-2 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200"
                  />
                </div>
              </div>
            </>
          )}

          <div className="w-full">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Type of Work
            </label>
            <Select
              name="type_of_work"
              options={typeOfWork?.map((work) => ({
                value: work.name,
                label: work.name,
              }))}
              value={
                typeOfWork
                  ?.map((work) => ({ value: work.name, label: work.name }))
                  .find(
                    (option) =>
                      option?.value === leadFilter?.type_of_work
                  ) || null
              }
              onChange={(selectedOption) =>
                handleChange({
                  target: {
                    name: "type_of_work",
                    value: selectedOption?.value || "",
                  },
                })
              }
              isMulti={false}
              isClearable={true}
              placeholder="Select Type of Work"
              className="react-select-container "
              classNamePrefix="select"
            />
          </div>

          <div className="w-full">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Sales / Service
            </label>
            <Select
              name="type"
              options={salesServiceOptions?.map((item) => ({
                value: item.value,
                label: item.name,
              }))}
              value={
                salesServiceOptions
                  ?.map((item) => ({
                    value: item.value,
                    label: item.name,
                  }))
                  .find(
                    (option) => option.value === leadFilter.type
                  ) || null
              }
              onChange={(selectedOption) =>
                handleChange({
                  target: {
                    name: "type",
                    value: selectedOption?.value || "",
                  },
                })
              }

              isMulti={false}
              isClearable={true}
              placeholder="Select Sales / Service"
              className="react-select-container"
              classNamePrefix="select"
            />
          </div>
          <div className="w-full">
            <label className="block text-sm font-medium text-gray-700 mb-2">
            Project Manager
            </label>
            <Select
              name="project_manager"
              options={projectManagerList?.map((item) => ({
                value: item.name,
                label: item.name,
              }))}
              value={
                projectManagerList
                  ?.map((item) => ({
                    value: item.name,
                    label: item.name,
                  }))
                  .find(
                    (option) => option.value === leadFilter.project_manager
                  ) || null
              }
              onChange={(selectedOption) =>
                handleChange({
                  target: {
                    name: "project_manager",
                    value: selectedOption?.value || "",
                  },
                })
              }

              isMulti={false}
              isClearable={true}
              placeholder="Select Project Manager"
              className="react-select-container"
              classNamePrefix="select"
            />
          </div>
        </div>

        <div className="flex flex-wrap gap-4 mt-4">
          {/* Submit Button */}
          <button
            onClick={() => handleFilter(1)}
            className="bg-blue-600 text-white font-semibold py-2 px-6 rounded-md hover:bg-blue-700 transition"
          >
            Submit
          </button>

          {/* Reset Button */}
          <button
            onClick={resetFilters}
            className="bg-gray-200 text-gray-800 font-semibold py-2 px-6 rounded-md hover:bg-gray-300 transition"
          >
            Reset
          </button>

          {/* <button
            onClick={downloadPDF}
            className="bg-gray-600 text-white font-semibold py-2 px-6 rounded-md hover:bg-gray-500 transition"
          >
            PDF
          </button> */}
        </div>
      </div>
      <div className=" p-4 rounded-lg ">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-4">
          <div
            className={`bg-white border rounded-lg shadow overflow-hidden ${fullscreenTable === "typeOfWork"
              ? "fixed inset-0 z-50 overflow-auto"
              : ""}`}
          >
            {/* Header */}
            <div className="flex justify-between items-center bg-purple-100 p-2">
              <h3 className="text-sm sm:text-lg font-semibold text-purple-700">
                Type Of Work Leads
              </h3>

              <div className="flex gap-2">


                <button
                  className=" rounded  bg-gray-600 py-2 px-3 "
                  onClick={() => downloadExcel("leadCountsByTypeOfWork" ,"Type Of Work Leads")}
                  title="Download Excel"
                >
                  <TableCellsIcon className="h-5 w-5 text-white" />
                </button>
                <button
                  className=" rounded  bg-gray-600 py-2 px-3 "
                  onClick={() => downloadPDF("leadCountsByTypeOfWork" , "Type Of Work Leads")}
                  title="Download PDF"
                >
                  <ArrowDownTrayIcon className="h-5 w-5 text-white" />
                </button>
                <button
                  className=" rounded  bg-gray-600 py-2 px-3 "
                  onClick={() =>
                    setFullscreenTable(
                      fullscreenTable === "typeOfWork" ? null : "typeOfWork"
                    )
                  }
                  title={
                    fullscreenTable === "typeOfWork"
                      ? "Close Fullscreen"
                      : "Fullscreen"
                  }
                >
                  {fullscreenTable === "typeOfWork" ? (
                    <XMarkIcon className="h-5 w-5 text-white" />
                  ) : (
                    <ArrowsPointingOutIcon className="h-5 w-5 text-white" />
                  )}
                </button>
              </div>


            </div>

            {/* Table Container */}
            <div className="overflow-x-auto">
              <div
                className={`overflow-y-auto ${fullscreenTable === "future"
                  ? "max-h-[calc(100vh-80px)]" // full height minus header
                  : "max-h-[400px]" // normal height
                  }`}
              >
                <table className="min-w-[700px] w-full border-collapse">
                  {/* Table Header */}
                  <thead className="bg-gray-100 ">
                    <tr className="text-center font-semibold border-b">
                      {[
                        "S No",
                        "Type of Work",
                        "Count ",
                        "Win",
                        "Loss",
                        "Followup",
                      ].map((header, idx) => (
                        <th
                          key={idx}
                          className="p-2 border-r last:border-r-0 text-xs sm:text-sm text-gray-900 bg-gray-100"
                        >
                          {header}
                        </th>
                      ))}
                    </tr>
                  </thead>

                  {/* Table Body */}
                  <tbody>
                    {statsDetails?.leadCountsByTypeOfWork?.length > 0 ? (
                      statsDetails?.leadCountsByTypeOfWork.map(
                        (person, index) => (
                          <tr
                            key={person.id}
                            className="text-center text-sm border-b hover:bg-gray-50"
                          >
                            <td className="p-2 border-r last:border-r-0">
                              {index + 1}
                            </td>
                            <td className="p-2 border-r last:border-r-0 break-words">
                              {person?.type_of_work_name || "N/A"}
                            </td>
                            <td className="p-2 border-r last:border-r-0 break-words">

                              {person?.count || "N/A"}

                            </td>
                            <td className="p-2 border-r last:border-r-0">
                              <div className="flex flex-wrap justify-center gap-1">
                                {person?.win || "0"}
                              </div>
                            </td>
                            <td className="p-2 border-r last:border-r-0">
                              {person.loss || "0"}
                            </td>
                            <td className="p-2">
                              {person.followup || "0"}
                            </td>
                          </tr>
                        )
                      )
                    ) : (
                      <tr>
                        <td
                          colSpan={6}
                          className="p-4 text-gray-500 text-center"
                        >
                          No data available for non-followed leads
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div
            className={`bg-white border rounded-lg shadow overflow-hidden ${fullscreenTable === "today"
              ? "fixed inset-0 z-50 overflow-auto"
              : ""
              }`}
          >
            {/* Full-width Header */}
            <div className="flex justify-between items-center bg-green-100 p-2 ">
              <h3 className="text-sm sm:text-lg font-semibold text-green-700">
                 Today's Follow-up Leads
              </h3>

              <div className="flex gap-2">

                <button
                  className=" rounded  bg-gray-600 py-2 px-3 "
                  onClick={() => downloadExcel("todayLeadList" ,"Today's Follow-up Leads")}
                  title="Download Excel"
                >
                  <TableCellsIcon className="h-5 w-5 text-white" />
                </button>

                <button
                  className=" rounded  bg-gray-600 py-2 px-3 "
                  onClick={() => downloadPDF("todayLeadList" ,"Today's Follow-up Leads")}
                  title="Download PDF"
                >
                  <ArrowDownTrayIcon className="h-5 w-5 text-white" />
                </button>
                <button
                  className=" rounded  bg-gray-600 py-2 px-3"
                  onClick={() =>
                    setFullscreenTable(
                      fullscreenTable === "today" ? null : "today"
                    )
                  }
                  title={
                    fullscreenTable === "today"
                      ? "Close Fullscreen"
                      : "Fullscreen"
                  }
                >
                  {fullscreenTable === "today" ? (
                    <XMarkIcon className="h-5 w-5  text-white" />
                  ) : (
                    <ArrowsPointingOutIcon className="h-5 w-5   text-white" />
                  )}
                </button>
              </div>

            </div>

            {/* Table Scroll Container */}
            <div className="overflow-x-auto">
              <div
                className={`overflow-y-auto ${fullscreenTable === "today"
                  ? "max-h-[calc(100vh-80px)]" // fullscreen: almost full height
                  : "max-h-[400px]" // normal view
                  }`}
              >
                <table className="min-w-[700px] w-full border-collapse">
                  {/* Table Header */}
                  <thead className="bg-gray-100 ">
                    <tr className="text-center font-semibold border-b">
                      {[
                        "S No",
                        "Enquiry No",
                        "Party Name",
                        "Mobile No",
                        "Type Of Work",
                        ' Project Manager',
                        "Sales/Service",
                        "Lead Status",
                      ].map((header, idx) => (
                        <th
                          key={idx}
                          className="p-2 border-r last:border-r-0 text-xs sm:text-sm text-gray-900 bg-gray-100"
                        >
                          {header}
                        </th>
                      ))}
                    </tr>
                  </thead>

                  {/* Table Body */}
                  <tbody>
                    {statsDetails?.todayLeadList?.length > 0 ? (
                      statsDetails.todayLeadList.map((person, index) => (
                        <tr
                          key={person.id}
                          className="text-center text-sm border-b hover:bg-gray-50"
                        >
                          <td className="p-2 border-r last:border-r-0">
                            {index + 1}
                          </td>
                          <td className="p-2 border-r last:border-r-0 break-words">
                            {person.enquiry_no || "N/A"}
                          </td>

                          <td className="p-2 border-r last:border-r-0 break-words">
                            {person.customer_name || "N/A"}
                          </td>
                          
                          <td className="p-2 border-r last:border-r-0 break-words">
                            <a
                              href={`tel:${person.contact_no}`}
                              className="text-blue-600 hover:underline"
                            >
                              {person.contact_no || "N/A"}
                            </a>
                          </td>
                          <td className="p-2 border-r last:border-r-0">
                            <div className="flex flex-wrap justify-center gap-1">
                              {person.type_of_work?.length > 0
                                ? person.type_of_work.map((work) => (
                                  <span
                                    key={work.id}
                                    className="text-xs rounded px-1"
                                    style={{
                                      color: todayLeadColorMap[work.id],
                                      border: `1px solid ${todayLeadColorMap[work.id]
                                        }`,
                                    }}
                                  >
                                    {work.name || "N/A"}
                                  </span>
                                ))
                                : "N/A"}
                            </div>
                          </td>
                          <td className="p-2 border-r last:border-r-0">
                            {person.project_manager || "N/A"}
                          </td>
                          <td className="p-2 border-r last:border-r-0">
                            {person.sales_service || "N/A"}
                          </td>
                          <td className="p-2">
                            {person.lead_status
                              ? person.lead_status
                                .charAt(0)
                                .toUpperCase() +
                              person.lead_status.slice(1)
                              : "N/A"}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan={6}
                          className="p-4 text-gray-500 text-center"
                        >
                          No data available for today's leads
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div
            className={`bg-white border rounded-lg shadow overflow-hidden ${fullscreenTable === "unfollowed"
              ? "fixed inset-0 z-50 overflow-auto"
              : ""
              }`}
          >
            {/* Header */}
            <div className="flex justify-between items-center bg-red-100 p-2">
              <h3 className="text-sm sm:text-lg font-semibold text-red-700">
                UnFollowed Leads
              </h3>

              <div className="flex gap-2">
                <button
                  className=" rounded  bg-gray-600 py-2 px-3 "
                  onClick={() => downloadExcel("unFollowedLeadsList" ,"UnFollowed Leads")}
                  title="Download Excel"
                >
                  <TableCellsIcon className="h-5 w-5 text-white" />
                </button>

                <button
                  className=" rounded  bg-gray-600 py-2 px-3 "
                  onClick={() => downloadPDF("unFollowedLeadsList","UnFollowed Leads")}
                  title="Download PDF"
                >
                  <ArrowDownTrayIcon className="h-5 w-5 text-white" />
                </button>
                <button
                  className="rounded  bg-gray-600 py-2 px-3"
                  onClick={() =>
                    setFullscreenTable(
                      fullscreenTable === "unfollowed" ? null : "unfollowed"
                    )
                  }
                  title={
                    fullscreenTable === "unfollowed"
                      ? "Close Fullscreen"
                      : "Fullscreen"
                  }
                >
                  {fullscreenTable === "unfollowed" ? (
                    <XMarkIcon className="h-5 w-5 text-white" />
                  ) : (
                    <ArrowsPointingOutIcon className="h-5 w-5 text-white" />
                  )}
                </button>
              </div>

            </div>

            {/* Table Container */}
            <div className="overflow-x-auto">
              <div
                className={`overflow-y-auto ${fullscreenTable === "unfollowed"
                  ? "max-h-[calc(100vh-80px)]" // full height minus header
                  : "max-h-[400px]" // normal height
                  }`}
              >
                <table className="min-w-[700px] w-full border-collapse">
                  {/* Table Header */}
                  <thead className="bg-gray-100 ">
                    <tr className="text-center font-semibold border-b">
                      {[
                        "S No",
                        "Enquiry No",
                        "Party Name",
                        "Mobile No",
                        "Type Of Work",
                        "Project Manager",
                        "Sales/Service",
                        "Lead Status",
                      ].map((header, idx) => (
                        <th
                          key={idx}
                          className="p-2 border-r last:border-r-0 text-xs sm:text-sm text-gray-900 bg-gray-100"
                        >
                          {header}
                        </th>
                      ))}
                    </tr>
                  </thead>

                  {/* Table Body */}
                  <tbody>
                    {statsDetails?.nonFollowedLeadList?.length > 0 ? (
                      statsDetails.nonFollowedLeadList.map(
                        (person, index) => (
                          <tr
                            key={person.id}
                            className="text-center text-sm border-b hover:bg-gray-50"
                          >
                            <td className="p-2 border-r last:border-r-0">
                              {index + 1}
                            </td>
                            <td className="p-2 border-r last:border-r-0 break-words">
                              {person.enquiry_no || "N/A"}
                            </td>
                            <td className="p-2 border-r last:border-r-0 break-words">
                              {person.customer_name || "N/A"}
                            </td>
                            <td className="p-2 border-r last:border-r-0 break-words">
                              <a
                                href={`tel:${person.contact_no}`}
                                className="text-blue-600 hover:underline"
                              >
                                {person.contact_no || "N/A"}
                              </a>
                            </td>
                            <td className="p-2 border-r last:border-r-0">
                              <div className="flex flex-wrap justify-center gap-1">
                                {person.type_of_work?.length > 0
                                  ? person.type_of_work.map((work) => (
                                    <span
                                      key={work.id}
                                      className="text-xs rounded px-1"
                                      style={{
                                        color: randomColorMap[work.id],
                                        border: `1px solid ${randomColorMap[work.id]
                                          }`,
                                      }}
                                    >
                                      {work.name || "N/A"}
                                    </span>
                                  ))
                                  : "N/A"}
                              </div>
                            </td>

                            <td className="p-2 border-r last:border-r-0">
                              {person.project_manager || "N/A"}
                            </td>
                            <td className="p-2 border-r last:border-r-0">
                              {person.sales_service || "N/A"}
                            </td>
                            <td className="p-2">
                              {person.lead_status
                                ? person.lead_status
                                  .charAt(0)
                                  .toUpperCase() +
                                person.lead_status.slice(1)
                                : "N/A"}
                            </td>
                          </tr>
                        )
                      )
                    ) : (
                      <tr>
                        <td
                          colSpan={6}
                          className="p-4 text-gray-500 text-center"
                        >
                          No data available for non-followed leads
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div
            className={`bg-white border rounded-lg shadow overflow-hidden ${fullscreenTable === "future"
              ? "fixed inset-0 z-50 overflow-auto"
              : ""
              }`}
          >
            {/* Header */}
            <div className="flex justify-between items-center bg-stone-100 p-2">
              <h3 className="text-sm sm:text-lg font-semibold text-stone-700">
                 Future Follow-up Leads
              </h3>

              <div className="flex gap-2">
                <button
                  className=" rounded  bg-gray-600 py-2 px-3 "
                  onClick={() => downloadExcel("futureLeadList" , "Future Follow-up Leads")}
                  title="Download Excel"
                >
                  <TableCellsIcon className="h-5 w-5 text-white" />
                </button>

                <button
                  className=" rounded  bg-gray-600 py-2 px-3 "
                  onClick={() => downloadPDF("futureLeadList", "Future Follow-up Leads")}
                  title="Download PDF"
                >
                  <ArrowDownTrayIcon className="h-5 w-5 text-white" />
                </button>

                <button
                  className="p-2 rounded bg-gray-600 py-2 px-3"
                  onClick={() =>
                    setFullscreenTable(
                      fullscreenTable === "future" ? null : "future"
                    )
                  }
                  title={
                    fullscreenTable === "future"
                      ? "Close Fullscreen"
                      : "Fullscreen"
                  }
                >
                  {fullscreenTable === "future" ? (
                    <XMarkIcon className="h-5 w-5 text-white" />
                  ) : (
                    <ArrowsPointingOutIcon className="h-5 w-5 text-white" />
                  )}
                </button>
              </div>

            </div>

            {/* Table Container */}
            <div className="overflow-x-auto">
              <div
                className={`overflow-y-auto ${fullscreenTable === "future"
                  ? "max-h-[calc(100vh-80px)]" // full height minus header
                  : "max-h-[400px]" // normal height
                  }`}
              >
                <table className="min-w-[700px] w-full border-collapse">
                  {/* Table Header */}
                  <thead className="bg-gray-100 ">
                    <tr className="text-center font-semibold border-b">
                      {[
                        "S No",
                        "Enquiry No",
                        "Party Name",
                        "Mobile No",
                        "Type Of Work",
                        "Project Manager",
                        "Sales/Service",
                        "Lead Status",
                      ].map((header, idx) => (
                        <th
                          key={idx}
                          className="p-2 border-r last:border-r-0 text-xs sm:text-sm text-gray-900 bg-gray-100"
                        >
                          {header}
                        </th>
                      ))}
                    </tr>
                  </thead>

                  {/* Table Body */}
                  <tbody>
                    {statsDetails?.futureLeadList?.length > 0 ? (
                      statsDetails.futureLeadList.map(
                        (person, index) => (
                          <tr
                            key={person.id}
                            className="text-center text-sm border-b hover:bg-gray-50"
                          >
                            <td className="p-2 border-r last:border-r-0">
                              {index + 1}
                            </td>
                            <td className="p-2 border-r last:border-r-0 break-words">
                              {person.enquiry_no || "N/A"}
                            </td>
                            <td className="p-2 border-r last:border-r-0 break-words">
                              {person.customer_name || "N/A"}
                            </td>
                            
                            <td className="p-2 border-r last:border-r-0 break-words">
                              <a
                                href={`tel:${person.contact_no}`}
                                className="text-blue-600 hover:underline"
                              >
                                {person.contact_no || "N/A"}
                              </a>
                            </td>
                            <td className="p-2 border-r last:border-r-0">
                              <div className="flex flex-wrap justify-center gap-1">
                                {person.type_of_work?.length > 0
                                  ? person.type_of_work.map((work) => (
                                    <span
                                      key={work.id}
                                      className="text-xs rounded px-1"
                                      style={{
                                        color: futureLeadColorMap[work.id],
                                        border: `1px solid ${futureLeadColorMap[work.id]
                                          }`,
                                      }}
                                    >
                                      {work.name || "N/A"}
                                    </span>
                                  ))
                                  : "N/A"}
                              </div>
                            </td>

                            <td className="p-2 border-r last:border-r-0">
                              {person?.project_manager || "N/A"}
                            </td>

                            <td className="p-2 border-r last:border-r-0">
                              {person?.sales_service || "N/A"}
                            </td>
                            <td className="p-2">
                              {person?.lead_status
                                ? person?.lead_status
                                  .charAt(0)
                                  .toUpperCase() +
                                person?.lead_status.slice(1)
                                : "N/A"}
                            </td>
                          </tr>
                        )
                      )
                    ) : (
                      <tr>
                        <td
                          colSpan={6}
                          className="p-4 text-gray-500 text-center"
                        >
                          No data available for non-followed leads
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>


        </div>
      </div>
    </div>
  )
}

export default LeadReportList